import { _ } from './../utils.js'
export default class BasketSteps {
    constructor(el) {
        this.el = el
        this.basket = _('basket', 'element').node()
        this.basketSections = _('step-section', 'element').nodesFrom(
            this.basket,
        )
        this.updateSteps = _('update-steps').nodesFrom(this.basket)
        this.observerConfig = {
            attributes: true,
            childList: false,
            subtree: false,
        }
        this.createSteps()

        this.basketSections.map((section) => {
            const observer = new MutationObserver(this.createSteps)
            observer.observe(section, this.observerConfig)
        })
    }

    createSteps = () => {
        let innerSteps = ''
        this.basketSections.map((section) => {
            const sectionName = section.dataset.stepId
            const isComplete = section.classList.contains(
                'store-checkout-form-group-complete',
            )
            const isActive = section.classList.contains(
                'store-active-form-group',
            )

            innerSteps += `<li class="steps__item">
                <span class="steps__link steps__link--unlink
                ${isComplete ? 'steps__link--done' : ''}
                ${isActive ? 'steps__link--active' : ''}
                ${!isActive && !isComplete ? 'steps__link--disabled' : ''}
                ">${sectionName}</span>
            </li>`
        })
        this.el.innerHTML = `
        <div class="container">
            <ul class="steps">
                ${innerSteps}
            </ul>
        </div>`
    }
}
